import { X } from 'lucide-react';
import { useEffect } from 'react';

interface CoreValueModalProps {
  isOpen: boolean;
  onClose: () => void;
  value: {
    title: string;
    fullDescription: string;
  } | null;
}

export default function CoreValueModal({ isOpen, onClose, value }: CoreValueModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !value) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} />
      
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg max-w-2xl w-full p-6 md:p-8">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brown-500"
          >
            <X className="w-6 h-6" />
          </button>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h2>
          <div className="prose prose-brown max-w-none">
            <p className="text-gray-600 leading-relaxed">{value.fullDescription}</p>
          </div>
        </div>
      </div>
    </div>
  );
}